import React from 'react';
import PropTypes from 'prop-types';
import { useLeagueSettings } from '../../context/LeagueSettingsContext';
import HiddenText from '../HiddenText';
import styles from './MobileGenericLockCard.module.css';
import { formatGameDateTime } from '../../utils/timeUtils';

const LockClosedIcon = () => (
  <svg className={styles.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
);

const MobileGenericLockCard = ({ game, locks, displayedWeek }) => {
  const { canSeeLockers } = useLeagueSettings();
  const { displayDate, displayTime } = formatGameDateTime(game.start_date);

  // Show username if lockers are visible, otherwise show hidden text
  const showUsername = canSeeLockers(displayedWeek, false, 0, 1);

  return (
    <div className={styles.genericLockCard}>
      <div className={styles.lockIcon}>
        <LockClosedIcon />
      </div>
      <div className={styles.content}>
        <div className={styles.lockText}>
          {showUsername ? (
            <span className={styles.username}>{locks[0]?.username || 'Unknown'}</span>
          ) : (
            <HiddenText
              type="locker"
              weekNumber={displayedWeek}
              showTooltip={true}
            />
          )}
          <span className={styles.hasLockedText}> has locked</span>
        </div>
        <div className={styles.gameInfo}>
          {displayDate} • {displayTime}
        </div>
      </div>
    </div>
  );
};

MobileGenericLockCard.propTypes = {
  game: PropTypes.object.isRequired,
  locks: PropTypes.array.isRequired,
  displayedWeek: PropTypes.number.isRequired,
};

export default MobileGenericLockCard;

